import { vnModule_knockoutJS } from '../../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler } from '../../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { header } from '../header';
import { adminQuestionBankEdit_template } from '../../components/templates/recruiting/adminQuestionBankEdit_template';
import { hideLoadingOverlay, showLoadingOverlay } from '~/utils/listLoading';
export class admin_question_bank_edit extends vnModule_knockoutJS {
    /**
     * Return the module key used by the Valnet app framework.
     *
     * @return string
     */
    getModuleName() {
        return 'admin_question_bank_edit';
    }
    /**
     * Build and return the DOM content for this module.
     *
     * @return Array<Element>
     */
    buildContent() {
        const zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        const loadedModule = zoneHeader.loadedModule;
        loadedModule.setHeaderTitle('Question Bank');
        this.tpl = new adminQuestionBankEdit_template('adminQuestionBankEditTemplate', this.viewModel, this);
        this.template = this.tpl;
        return [this.tpl.build()];
    }
    /**
     * Load the initial data required by the page.
     *
     * @return void
     */
    fillPage() {
        showLoadingOverlay(this.tpl.builtTemplate, 'Loading question bank...');
        this.XHRHdl = new XMLHttpRequestHandler('/api/admin/rest/api/lead/recruiting/bank/references', [], this);
        this.XHRHdl.onReadyStateFunction = this.onReferencesReturn;
        this.XHRHdl.execute();
    }
    /**
     * Handle the API response for references.
     *
     * @param req any
     * @param obj any
     * @return () => void
     */
    onReferencesReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response || '{}');
                obj.tpl.setAvailableQuestions(responseParsed.questions || []);
                obj.loadBank();
            });
            if (req.request.readyState === 4 && req.request.status !== 0 && !obj.getBankId()) {
                hideLoadingOverlay(obj.tpl.builtTemplate);
            }
        };
    }
    /**
     * Load bank data from the API.
     *
     * @return void
     */
    loadBank() {
        const bankId = this.getBankId();
        if (!bankId) {
            this.tpl.setBank({
                active: true,
                pages: [],
            });
            hideLoadingOverlay(this.tpl.builtTemplate);
            return;
        }
        this.XHRHdl = new XMLHttpRequestHandler('/api/admin/rest/api/lead/recruiting/bank/' + bankId, [], this);
        this.XHRHdl.onReadyStateFunction = this.onBankReturn;
        this.XHRHdl.execute();
    }
    /**
     * Handle the API response for bank.
     *
     * @param req any
     * @param obj any
     * @return () => void
     */
    onBankReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response || '{}');
                obj.tpl.setBank(responseParsed);
            });
            if (req.request.readyState === 4 && req.request.status !== 0) {
                hideLoadingOverlay(obj.tpl.builtTemplate);
            }
        };
    }
    /**
     * Save question bank through the API.
     *
     * @return Promise<void>
     */
    async saveQuestionBank() {
        const payload = this.tpl.getPayload();
        if (!payload.identifier) {
            alert('Identifier is required.');
            return;
        }
        showLoadingOverlay(this.tpl.builtTemplate, 'Saving question bank...');
        const response = await fetch('/api/admin/rest/api/lead/recruiting/bank', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });
        const result = await response.json();
        hideLoadingOverlay(this.tpl.builtTemplate);
        if (!response.ok || Number(result.status || 0) !== 200) {
            alert(result.message || 'Unable to save question bank.');
            return;
        }
        page('/admin/questionBank/' + result.objectId);
    }
    /**
     * Delete question bank through the API.
     *
     * @return Promise<void>
     */
    async deleteQuestionBank() {
        const bankId = this.getBankId();
        if (!bankId || !confirm('Delete this question bank?')) {
            return;
        }
        showLoadingOverlay(this.tpl.builtTemplate, 'Deleting question bank...');
        const response = await fetch('/api/admin/rest/api/lead/recruiting/bank/' + bankId, {
            method: 'DELETE',
            credentials: 'same-origin',
        });
        hideLoadingOverlay(this.tpl.builtTemplate);
        if (!response.ok) {
            alert('Unable to delete question bank.');
            return;
        }
        page('/admin/questionBanks');
    }
    /**
     * Navigate back to question banks.
     *
     * @return void
     */
    backToQuestionBanks() {
        page('/admin/questionBanks');
    }
    /**
     * Return bank id.
     *
     * @return number
     */
    getBankId() {
        const id = this.getVnAppZone().app.params.id;
        return id && id !== 'new' ? Number(id) : 0;
    }
}
